import { Step } from "react-joyride";

const waitFor = (selector: string, timeoutMs = 2000): Promise<void> =>
  new Promise((resolve) => {
    if (document.querySelector(selector)) {
      resolve();
      return;
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
      resolve();
    }, timeoutMs);
  });

const openManagePipelineOrder = async () => {
  if (document.querySelector(".tour-add-pipeline-step")) return;
  (document.querySelector(".tour-manage-pipeline-order") as HTMLElement | null)?.click();
  await waitFor(".tour-add-pipeline-step");
};

const closeManagePipelineOrder = () => {
  (document.querySelector(".tour-pipeline-order-cancel") as HTMLElement | null)?.click();
};

const opportunitiesPageTourSteps: Step[] = [
  {
    target: ".tour-create-opportunity",
    content: "Create a new opportunity. Click the button to continue.",
    buttons: ["close", "primary"],
    overlayClickAction: false,
  },
  ///create opportunities before all these steps....
  {
    target: ".tour-search-opportunities",
    content: "Find specific jobs, no matter where they are in the pipeline.",
  },
  {
    target: ".tour-column-headers",
    content: "Arrange or Filter your Opportunities.",
  },
  {
    target: ".tour-view-toggle",
    content: "View your Opportunities in List or Pipeline view.",
  },
  {
    target: ".tour-manage-pipeline-order",
    content:
      "Click here to organize how Opportunities will display by their status in the pipeline.",
    buttons: ["close", "primary"],
    overlayClickAction: false,
    styles: {
      // The user must click the real button to open the modal and advance the tour;
      // this hides the tooltip's own Next button without removing it, since a hidden
      // click on it is what actually advances Joyride once the real button is clicked.
      buttonPrimary: {
        opacity: 0,
        pointerEvents: "none",
        position: "absolute",
        width: 1,
        height: 1,
        padding: 0,
        overflow: "hidden",
      },
    },
  },
  {
    target: ".tour-add-pipeline-step",
    content: "You can create steps in your pipeline here.",
    before: openManagePipelineOrder,
    after: closeManagePipelineOrder,
  },
];

export default opportunitiesPageTourSteps;
